import { render, staticRenderFns } from "./ReviewResults.vue?vue&type=template&id=117ad424&scoped=true"
import script from "./ReviewResults.vue?vue&type=script&lang=js"
export * from "./ReviewResults.vue?vue&type=script&lang=js"
import style0 from "./ReviewResults.vue?vue&type=style&index=0&id=117ad424&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ad424",
  null
  
)

export default component.exports